import {useEffect, useContext} from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import AppContext from '../../contexts/AppContext';
import apiFetch from "../../helperFunctions/api";



export default function SessionSelect(){
  let {API, setSession, session, sessionOptions, setSessionOptions, navigate} = useContext(AppContext);



  const handleChange = (event) => {
    setSession(event.target.value);
    const selected = sessionOptions.find((option) => option.name === event.target.value);
    if (selected) navigate(`/sessions/${selected.id}`);
  };

  function getActiveSessions() {
    apiFetch(`${API}/session`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => setSessionOptions(data))
      .catch((err) => console.log(err));
  }

  useEffect(()=>{
    getActiveSessions();
    // Refresh on mount; changing the selection navigates to a different session.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  return(

    <FormControl fullWidth>
    <InputLabel  id="demo-simple-select-label">Session</InputLabel>
      <Select
      labelId="demo-simple-select-label"
      id="session-name"
      value={sessionOptions.some((option) => option.name === session) ? session : ""}
      label="Session Name"
      onChange={handleChange}
      >
      {sessionOptions.map((session) => {
      return <MenuItem key={session.id} value={session.name}>{session.name}</MenuItem>})}
      </Select>
    </FormControl>

  )
}